module.exports = __webpack_public_path__ + "img/logo_vertical_white.6b6343d4.svg";